import React from "react";
import _ from "lodash";
import { useDispatch } from "react-redux";
import { getCompanyFormatDate } from "../../helpers/DateUtils";
import {
  loadCompletedDiagnosis,
  loadCompletedTreatments,
} from "../../actions/chartSideClinicalNoteActions";

const TransactionsTable = ({
  isExpanded,
  onAppointment = false,
  completedDiagnosisList,
  completedTreatmentList,
  fetchingCompletedTreatments,
  fetchingCompletedDiagnosis,
}) => {
  const dispatch = useDispatch();
  const scrollHandler = (event, type) => {
    const scrollBottom =
      event.target.scrollTop + event.target.offsetHeight === event.target.scrollHeight;

    if (scrollBottom && !fetchingCompletedDiagnosis && !fetchingCompletedTreatments) {
      if (type === "diagnosis") {
        dispatch(loadCompletedDiagnosis(onAppointment));
      } else if (type === "treatment") {
        dispatch(loadCompletedTreatments(onAppointment));
      }
    }
  };

  return (
    <div className={`dx-trx-section ${isExpanded ? "" : "collapsed"}`}>
      <div className="dx-trx-content">
        <div className="diagnosis-section" onScroll={(event) => scrollHandler(event, "diagnosis")}>
          <h3 className="title">DIAGNOSIS</h3>
          <table className="dx-trx-content__table">
            <thead className="dx-trx-content__table__header">
              <tr>
                <th style={{ width: "105px" }}>Planned Date</th>
                <th style={{ width: "105px" }}>Date</th>
                <th style={{ width: "115px" }}>Code</th>
                <th>Description</th>
                <th style={{ width: "100px" }}>Area</th>
                <th style={{ width: "105px" }}>Area Details</th>
                <th style={{ width: "200px" }}>Doctor</th>
              </tr>
            </thead>
            <tbody className="dx-trx-content__table__body">
              {completedDiagnosisList.map((diagnosis) => (
                <tr key={diagnosis.key}>
                  <td>
                    {diagnosis.createdDate ? getCompanyFormatDate(diagnosis.createdDate) : ""}
                  </td>
                  <td>
                    {diagnosis.completedDate ? getCompanyFormatDate(diagnosis.completedDate) : ""}
                  </td>
                  <td>{_.get(diagnosis, "diagnosisItem.name", "diagnosis.diagnosisItem.code")}</td>
                  <td>{_.get(diagnosis, "diagnosisItem.description", "")}</td>
                  <td>{_.get(diagnosis, "area.name", "")}</td>
                  <td>
                    {_.get(diagnosis, "areaDetails", [])
                      .map((item) => (item.code.length < 3 ? item.code : item.name))
                      .join(", ")}
                  </td>
                  <td>{_.get(diagnosis, "closedDentist.name", "")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="treatment-section" onScroll={(event) => scrollHandler(event, "treatment")}>
          <h3 className="title">TREATMENT CODES</h3>
          <table className="dx-trx-content__table">
            <thead className="dx-trx-content__table__header">
              <tr>
                <th style={{ width: "105px" }}>Planned Date</th>
                <th style={{ width: "115px" }}>Completed Date</th>
                <th style={{ width: "100px" }}>Code</th>
                <th>Description</th>
                <th style={{ width: "100px" }}>Area</th>
                <th style={{ width: "105px" }}>Area Details</th>
                <th style={{ width: "110px" }}>Status</th>
                <th style={{ width: "200px" }}>Doctor</th>
              </tr>
            </thead>
            <tbody className="dx-trx-content__table__body">
              {completedTreatmentList.map((treatment) => (
                <tr key={treatment.key}>
                  <td>
                    {treatment.createdDate ? getCompanyFormatDate(treatment.createdDate) : ""}
                  </td>
                  <td>
                    {treatment.completedDate ? getCompanyFormatDate(treatment.completedDate) : ""}
                  </td>
                  <td>{_.get(treatment, "treatmentItem.name", "treatment.treatmentItem.code")}</td>
                  <td>
                    {_.get(
                      treatment,
                      "treatmentItem.description",
                      "treatment.treatmentItem.description2",
                    )}
                  </td>
                  <td>{_.get(treatment, "area.name", "")}</td>
                  <td>
                    {_.get(treatment, "areaDetails", [])
                      .map((item) => (item.code.length < 3 ? item.code : item.name))
                      .join(", ")}
                  </td>
                  <td>{_.get(treatment, "status.name")}</td>
                  <td>{_.get(treatment, "closedDentist.name", "")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default TransactionsTable;
